import Header from '../../components/Header'
import Footer from '../../components/Footer' 
import { Button } from '@mui/material'
import ButtonDivToPDF from '../../components/GlobalCarteiras/ButtonDivToPDF'
import GlobalPdf2025 from '../../components/GlobalCarteiras/GlobalPdf2025' 
import GlobalPdf2026 from '../../components/GlobalCarteiras2026/GlobalPdf2026'
import ButtonPng2026 from '../../components/GlobalCarteiras2026/ButtonDivToPDF2026'

export default function MinhaCarteira() {

    const user = localStorage.getItem("user")
    const state = JSON.parse(user)


    const openWhatsApp = () => {
        const phoneNumber = "5531996092454";
        const message = `Olá! Gostaria de solicitar a renovação da carteira do estudante: ${state.nome}, email: ${state.email}.`;
        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
    };



    const expired = { codigoUso: '', cpf: '', dataNascimento: '', escolaridade: '', nome: '', curso: '', rg: '', validadeCarteirinha: '', imagem: '', email: '', instituicao: '' }

    return (
        <div>

            <>
                {state.ano == 2025 && <GlobalPdf2025 />}
            </>

            <Header /> 
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>

                    <>
                        {state.ano == 2025 && <GlobalPdf2025 show={true} />}
                    </>
                    <>
                        {state.ano == 2026 && <GlobalPdf2026 show={true} />}
                    </>

                </div>
                <>
                    {state.ano == 2025 && <ButtonDivToPDF textButton='Baixar 2025' nome={state.nome} email={state.email} />}
                </>
                <>
                    {state.ano == 2026 && <ButtonPng2026 nome={state.nome} textButton={"Baixar Digital"} cpf={state.cpf} id="node_to_pdf2026" />}
                </>
                <>
                    {(state.ano !== '2025' && state.ano !== '2026') && <Button onClick={openWhatsApp} variant="outlined" style={{ width: '150px', alignSelf: 'center', marginBottom: '50px' }} color="error">Expirada!</Button>}
                </>

            </div>
            <Footer />

        </div>
    )
}
